import { KeyValuePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DemoRadioGroupFields } from '@demo/data/demo-cipo-fields';
import { CipoControlComponent } from '@shared/components/fields/cipo-control/cipo-control.component';
import { CipoListControl } from '@shared/components/fields/common';

@Component({
  selector: 'app-demo-cipo-radio-group',
  imports: [CipoControlComponent, FlexLayoutModule, KeyValuePipe],
  templateUrl: './demo-cipo-radio-group.component.html',
})
export class DemoCipoRadioGroupComponent {
  fb = inject(FormBuilder);

  form = signal(new FormGroup<{ [x: string]: CipoListControl }>({}));

  constructor() {
    DemoRadioGroupFields.forEach(field => {
      const { name, defaultValue, ...props } = field;
      const control = new CipoListControl(defaultValue, props);
      this.form().addControl(name, control);
    });
  }
}
